<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <br />
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
let self = {};
export default {
  name: "TableCdbResource",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      columns: [
        {
          title: this.$t("RAM.TENCENT.CDB.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.TENCENT.CDB.instanceId"),
          key: "instanceId"
        },
        {
          title: this.$t("RAM.TENCENT.CDB.name"),
          key: "name"
        },
        {
          title: this.$t("RAM.TENCENT.CDB.region"),
          key: "regionName"
        },
        {
          title: this.$t("RAM.TENCENT.CDB.engine"),
          key: "engine"
        },
        {
          title: this.$t("RAM.TENCENT.CDB.engineVersion"),
          key: "engineVersion"
        },
        {
          title: this.$t("RAM.TENCENT.CDB.cpu"),
          key: "cpu"
        },
        {
          title: this.$t("RAM.TENCENT.CDB.memory"),
          key: "memory"
        },
        {
          title: this.$t("RAM.TENCENT.CDB.volume"),
          key: "volume"
        },
        {
          title: this.$t("RAM.TENCENT.CDB.statusName"),
          key: "statusName"
        },
        {
          title: this.$t("RAM.TENCENT.CDB.vip"),
          key: "vip"
        },
        {
          title: this.$t("RAM.TENCENT.CDB.vport"),
          key: "vport"
        },
        {
          title: this.$t("RAM.TENCENT.CDB.instanceCreatedTime"),
          key: "instanceCreatedTime"
        }
      ],
      tableData: []
    };
  },
  created() {
    this._handleCompanyId = val => { this.companyId = val; };
    this._handleAccountSearchKey = val => { this.accountSearchKey = val; };
    this._handleAccountName = val => { this.accountName = val; };
    this._handleInstanceId = val => { this.instanceId = val; };
    eventBus.$on("companyId", this._handleCompanyId);
    eventBus.$on("accountSearchKey", this._handleAccountSearchKey);
    eventBus.$on("accountName", this._handleAccountName);
    eventBus.$on("instanceId", this._handleInstanceId);
    self = this;
  },
  methods: {
    showAll() {
      self.current = 1;
      self.getData();
    },
    getData() {
      self.$api.resourceManagement
        .selectTencentCdbByPage({
          companyId: self.companyId,
          accountName: self.accountName,
          instanceId: self.instanceId,
          accountIdList: self.accountSearchKey,
          pageNum: self.current,
          pageSize: self.pageSize
        })
        .then(res => {
          this.tableData = res.data.records;
          this.current = res.data.current;
          this.dataTotal = res.data.total;
        });
    },
    changePage(current) {
      this.current = current;
      this.getData();
    },
    changeSize(pageSize) {
      this.pageSize = pageSize;
      this.getData();
    }
  },
  beforeDestroy() {
    eventBus.$off("companyId", this._handleCompanyId);
    eventBus.$off("accountSearchKey", this._handleAccountSearchKey);
    eventBus.$off("accountName", this._handleAccountName);
    eventBus.$off("instanceId", this._handleInstanceId);
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/tencent/cdb/TableCdbResource.vue